import type { PresetColorType } from 'antd/es/_util/colors';

import type { PaymentStatus } from 'app/typings/core/common/enum/paymentStatus';

type FormatVCCStatus = {
  [key in PaymentStatus]: {
    label: string;
    color?: PresetColorType;
  };
};

export const formatPaymentStatus = (
  paymentStatus: PaymentStatus
): FormatVCCStatus[PaymentStatus] => {
  // eslint-disable-next-line @typescript-eslint/no-shadow -- inner-scope reuse, not a bug
  const formatPaymentStatus: FormatVCCStatus = {
    PAYING: {
      label: 'Paying',
      color: 'blue',
    },
    PENDING: {
      label: 'Pending',
      color: 'blue',
    },
    PAID: {
      label: 'Paid',
      color: 'green',
    },
    FAILED: {
      label: 'Failed',
      color: 'red',
    },
    PENDING_FAILURE: {
      label: 'Pending failure',
      color: 'red',
    },
    EXPIRED: {
      label: 'Expired',
      color: undefined,
    },
  };

  return formatPaymentStatus[paymentStatus];
};
